export default __webpack_public_path__ + "static/media/macaroon.d8a6ae35.jpg";